import { MatchViewModel } from '../../backend/entryPoints/mapper/mapToMatchViewModel';

export const playerNameSetup: Record<string, string[][]> = {
    '1.MD': [[], []],
    '2.MD': [[], []],
    WD: [[], []],
    XD: [[], []],
    WS: [[], []],
    '1.MS': [[], []],
    '2.MS': [[], []],
    '3.MS': [[], []],
};

export const addPlayerNameToSetup = (game: string, player: string, side: string, index?: number) => {
    if (!(game in playerNameSetup)) {
        throw new Error(`${game} is not defined`);
    }
    const doubles = game.includes('D');
    if (index === undefined && doubles) {
        throw new Error('Index is required for doubles games');
    }
    if (index !== undefined && (index >= 2 || index < 0) && doubles) {
        throw new Error('Index out of bounds for doubles games');
    }
    if (index !== undefined && !doubles) {
        throw new Error('Indices are not allowed for singles');
    }
    playerNameSetup[game][side === 'home' ? 0 : 1][index ?? 0] = player;
};

export const convertPlayerNamesToMatchViewModel = () => {
    const result: MatchViewModel[] = [];
    for (const game in playerNameSetup) {
        const matchViewModel: MatchViewModel = {
            mode_string: game,
            mode: game.includes('D') ? 1 : 0,
            player_home: playerNameSetup[game][0],
            player_guest: playerNameSetup[game][1],
            games: [{ home_points: 0, guest_points: 0 }],
            player_positioning: game.includes('D')
                ? [
                      [0, 1],
                      [2, 3],
                  ]
                : [
                      [-1, 0],
                      [2, -1],
                  ],
            home_team: '',
            guest_team: '',
            serving_team: -1,
            server: -1,
            receiver: -1,
        };
        result.push(matchViewModel);
    }
    return result;
};
